import './App.css';
import {
  Button,
  Card,
  Divider,
  Image,
  Flex,
  message,
  Space,
  Typography,
  Skeleton,
  Modal,
  Form,
  Select,
  Slider,
  Switch,
} from 'antd';
import useSWR, { useSWRConfig } from 'swr';
import 'react-quill/dist/quill.snow.css';
import dayjs from 'dayjs';
import cookie from 'react-cookies';
import { LeftCircleOutlined, LinkOutlined } from '@ant-design/icons';

import { useNavigate, useParams } from 'react-router-dom';

import parse from 'html-react-parser';
import { HTMLReactParserOptions, Element } from 'html-react-parser';
import { useEffect, useState, useMemo } from 'react';
import LivePhoto from './LivePhoto';

const { Title, Text } = Typography;
const options: HTMLReactParserOptions = {
  replace(domNode) {
    if (domNode instanceof Element && domNode.attribs) {
      if (domNode.name === 'img') {
        if (domNode.attribs.class === 'ql-emotion') {
          return domNode;
        }
        return (
          // <LivePhoto
          //   src={domNode.attribs.src}
          //   className="marshmallow-image" // 可以加一个类名方便控制
          //   style={{ maxWidth: '100%' }} // 确保不溢出
          // />
          <Image
            style={{ maxHeight: '500px' }}
            src={domNode.attribs.src}
            loading='lazy'
          />
        );
      }
    }
  },
};
const fetcher = async (url: string) => {
  const token = cookie.load('token');
  const res = await fetch(url, {
    headers: new Headers({
      'Access-Control-Allow-Origin': '*',
      Authorization: `Bearer ${token}`,
    }),
  });
  const json = await res.json();
  if (!json.success) {
    const error = new Error((await json).message);
    throw error;
  }
  return json;
};

const ArchivedMarshmallowPreview = () => {
  const { id } = useParams();
  const { mutate } = useSWRConfig();
  const token = cookie.load('token');
  const [deleteOpen, setDeleteOpen] = useState(false);
  const [editOpen, setEditOpen] = useState(false);
  const [editForm] = Form.useForm();
  const [fontSize, setFontSize] = useState(20);
  const [lineHeight, setLineHeight] = useState(250);
  const archiveMarshmallow = async () => {
    const response = await (
      await fetch('https://api.lynne.com.cn/marshmallowManage/archive', {
        method: 'POST',
        body: JSON.stringify({
          id: id,
          archived: 1,
        }),
        headers: new Headers({
          'Access-Control-Allow-Origin': '*',
          'Content-type': 'Application/json',
          Authorization: `Bearer ${token}`,
        }),
      })
    ).json();
    if (response.success) {
      message.success(response.message);
      mutate(`https://api.lynne.com.cn/marshmallowManage/get?id=${id}`);
    } else {
      message.error(response.message);
    }
  };
  const unarchiveMarshmallow = async () => {
    const response = await (
      await fetch('https://api.lynne.com.cn/marshmallowManage/archive', {
        method: 'POST',
        body: JSON.stringify({
          id: id,
          archived: 0,
        }),
        headers: new Headers({
          'Access-Control-Allow-Origin': '*',
          'Content-type': 'Application/json',
          Authorization: `Bearer ${token}`,
        }),
      })
    ).json();
    if (response.success) {
      message.success(response.message);
      mutate(`https://api.lynne.com.cn/marshmallowManage/get?id=${id}`);
    } else {
      message.error(response.message);
    }
  };
  const deleteMarshmallow = async () => {
    const response = await (
      await fetch('https://api.lynne.com.cn/marshmallowManage/delete', {
        method: 'POST',
        body: JSON.stringify({
          id: id,
        }),
        headers: new Headers({
          'Access-Control-Allow-Origin': '*',
          'Content-type': 'Application/json',
          Authorization: `Bearer ${token}`,
        }),
      })
    ).json();
    if (response.success) {
      message.success(response.message);
      n('/dashboard');
    } else {
      message.error(response.message);
    }
  };
  const changeFontSize = (size: number) => {
    setFontSize(size);
    localStorage.setItem('fontSize', `${size}`);
  };
  const changeLineHeight = (height: number) => {
    setLineHeight(height);
    localStorage.setItem('lineHeight', `${lineHeight}`);
  };
  const changeFileAvailable = async (value: boolean, index: number) => {
    const response = await (
      await fetch(
        'https://api.lynne.com.cn/marshmallowManage/set_file_available',
        {
          method: 'POST',
          body: JSON.stringify({
            id: id,
            index,
            status: value,
          }),
          headers: new Headers({
            'Access-Control-Allow-Origin': '*',
            'Content-type': 'Application/json',
            Authorization: `Bearer ${token}`,
          }),
        }
      )
    ).json();
    if (response.success) {
      message.success(response.message);
      mutate(`https://api.lynne.com.cn/marshmallowManage/get?id=${id}`);
    } else {
      message.error(response.message);
    }
  };
  const { data, error, isLoading } = useSWR(
    `https://api.lynne.com.cn/marshmallowManage/get?id=${id}`,
    fetcher
  );
  const {
    data: categoryData,
    error: categoryError,
    isLoading: categoryIsLoading,
  } = useSWR('https://api.lynne.com.cn/marshmallowManage/category', fetcher);
  const n = useNavigate();
  useEffect(() => {
    document.body.scrollTop = 0;
    document.documentElement.scrollTop = 0;
    const fontSize = localStorage.getItem('fontSize');
    if (fontSize) {
      setFontSize(parseInt(fontSize));
    } else {
      setFontSize(20);
    }
    const lineHeight = localStorage.getItem('lineHeight');
    if (lineHeight) {
      setLineHeight(parseInt(lineHeight));
    } else {
      setLineHeight(250);
    }
  }, []);
  const stats = useMemo(() => {
    if (!data?.data?.content) return { textCount: 0, imageCount: 0 };
    
    const parser = new DOMParser();
    const tempDiv = parser.parseFromString(data.data.content, 'text/html');
    
    const textContent = tempDiv.getElementsByTagName('body')[0].innerText || '';
    const textCount = textContent.replace(/\s/g, '').length;
    const images = tempDiv.getElementsByTagName('img');
    const imageCount = images.length;

    return { textCount, imageCount };
  }, [data?.data?.content]); 
  if (
    isLoading ||
    categoryIsLoading ||
    data === undefined ||
    categoryData === undefined
  )
    return <Skeleton active />;
  if (error || categoryError) {
    if (error) {
      message.error(error.message);
    }
    if (categoryError) {
      message.error(categoryError.message);
    }
    n('/dashboard/archived');
  }
  const files = data.data.files === '' ? [] : data.data.files.split('|');
  const files_available =
    data.data.files_available === null || data.data.files_available === ''
      ? null
      : data.data.files_available.split('|');
  const categories = [];
  for (let i = 0; i < categoryData.data.length; i++) {
    categories.push({
      value: categoryData.data[i].id,
      label: categoryData.data[i].name,
    });
  }

  // 渲染数据
  return (
    <>
      <Modal
        open={deleteOpen}
        title='确认删除喵？'
        okText='删除'
        okType='danger'
        cancelText='取消'
        onCancel={() => setDeleteOpen(false)}
        onOk={() => deleteMarshmallow()}
        destroyOnClose>
        这个投稿会被删除喵！
      </Modal>
      <Flex align='center' gap={10}>
        <Button
          type='primary'
          shape='circle'
          icon={<LeftCircleOutlined />}
          onClick={() => n('/dashboard/archived')}
        />
        <Title level={3} style={{ margin: '15px 0', flex: 1 }}>
          收纳箱
        </Title>
      </Flex>
      <Divider />
      <Card style={{ fontSize: `${fontSize}px` }}>
        <Flex align='center' gap={10}>
          <Title
            level={3}
            style={{ margin: '15px 0', flex: 1 }}
            className='font'>
            {data.data.title}
          </Title>
        </Flex>
        <div
          style={{
            color: 'gray',
            marginBottom: '10px',
            fontSize: '16px',
          }}>
          {dayjs(data.data.time).format('投稿时间YYYY年MM月DD日 HH:mm:ss')}
        </div>
        <Flex gap={10} align='center' style={{ marginBottom: 10 }}>
          <div
            style={{
              fontSize: '16px',
            }}>
            字体大小
          </div>
          <Slider
            onChange={changeFontSize}
            style={{ flex: 1, maxWidth: '300px' }}
            defaultValue={fontSize}
            min={16}
            max={60}
          />
        </Flex>
        <Flex gap={10} align='center' style={{ marginBottom: 10 }}>
          <div
            style={{
              fontSize: '16px',
            }}>
            每行高度
          </div>
          <Slider
            onChange={changeLineHeight}
            style={{ flex: 1, maxWidth: '300px' }}
            defaultValue={lineHeight}
            min={100}
            max={300}
          />
        </Flex>
        <Flex align='center' gap={10} wrap>
          {data.data.archived ? (
            <Button type='primary' onClick={unarchiveMarshmallow}>
              取消收纳此稿件
            </Button>
          ) : (
            <Button type='primary' onClick={archiveMarshmallow}>
              收纳此稿件
            </Button>
          )}
          <Button type='primary' danger onClick={() => setDeleteOpen(true)}>
            删除此稿件
          </Button>
        </Flex>
        <Divider />
        <div className='marshmallow font'>
          全文共有{stats.textCount}字，{stats.imageCount}张图片，预计阅读时间{Math.ceil(stats.textCount / 250)}分钟~
        </div>
        <Divider />
        <div
          className='marshmallow font'
          style={{ lineHeight: `${lineHeight}%` }}>
          {parse(data.data.content, options)}
        </div>
        {files.length !== 0 && (
          <>
            <Divider />
            <Title level={4} style={{ margin: '15px 0', flex: 1 }}>
              附件列表
            </Title>
            <Space
              direction='vertical'
              size={'middle'}
              style={{ width: '100%' }}>
              {files.map((file: string, index: number) => {
                return (
                  <Flex align='center' key={file} gap={5}>
                    <Card
                      style={{ flex: 1 }}
                      hoverable
                      onClick={(e: any) => {
                        window.open(`https://dd.lynne.com.cn/file/${file}`);
                      }}>
                      <Flex align='center' gap={5}>
                        <LinkOutlined />
                        <div style={{ flex: 1 }}>{decodeURI(file)}</div>
                      </Flex>
                    </Card>
                    公开附件
                    <Switch
                      onChange={value => changeFileAvailable(value, index)}
                      defaultChecked={
                        files_available === null
                          ? false
                          : files_available[index] === 'true'
                      }
                    />
                  </Flex>
                );
              })}
            </Space>
          </>
        )}
      </Card>
    </>
  );
};

export default ArchivedMarshmallowPreview;
